import PropTypes from 'prop-types';
import React from 'react';
import CloseIcon from 'modules/Common/components/svg/CloseIcon';

require('./Notification.scss');

export default function Notification({
    showClose = true,
    children,
    onDismiss,
    className
  }) {

    return (
        <div className={[className, "notification"].join(' ')} >            
            <div className="notification-content">
                {children}

                {showClose ?
                <button className="close" onClick={onDismiss}>
                    <CloseIcon />
                </button> : null}
                
            </div>
            <div className="notification-background"></div>
        </div>
    );
}
  
Notification.propTypes = {
    showClose: PropTypes.bool,
    children: PropTypes.object,
    onDismiss: PropTypes.func,
    className: PropTypes.string
};


// WEBPACK FOOTER //
// ./modules/Common/components/Notification.js